import { Component } from '@angular/core';
import { SiAuthenticationService } from '@strategic-insights/ng-authentication';

@Component({
  template: `<div class="container-fluid">
  <div class="jumbotron">
    <h1 class="display-4">
      <i class="fa fa-lg fa-exclamation-triangle pe-2" style="color:orange;"></i>
      <b>Page not found!!</b>
    </h1>
    <div class="text-end pointer" title="Logout" (click)="logout()">
    <i class="fa fa-sign-out pe-1"></i>Logout
  </div>
  <br/>
    <h4>Oops! Requested page not found.</h4>
  </div>
</div>`
})
export class PageNotFoundComponent {
  constructor(private siAuthenticationService: SiAuthenticationService) {}
  logout() {
    this.siAuthenticationService.logout().subscribe(() => {});
  }
}
